import cx from 'classnames';
import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import {
  ISSUE_EXCEPTION_CREATED_BY_SORT,
  ISSUE_EXCEPTION_PACKAGE_SORT,
  ISSUE_EXCEPTION_SCOPE_SORT,
} from '../../../../shared/issuesV2';
import * as IssuesV2Store from '../../../redux/issuesV2';
import { BUTTON_SIZE } from '../../generic/Button/button-constants';
import DropdownButton from '../../generic/DropdownButton';
import Flex from '../../generic/Flex';
import SearchInput from '../../generic/Forms/SearchInput';
import { icons } from '../../generic/Icon/icons';
import { Icon } from '../../generic/Icon/index';
import PaginationRangeWithControl from '../../generic/Pagination/PaginationRangeWithControl';
import type { IssueExceptionSort } from '../../../../shared/issuesV2';

import type { UseIssueExceptionsResponse } from './useIssueExceptions';

import styles from './IssueExceptionsTable.module.less';

type Props = {
  search?: string;
  sortBy?: string;
  onChangeSortBy: (sortBy: IssueExceptionSort) => void;
  onChangeSearch: (search: string) => void;
} & Pick<UseIssueExceptionsResponse, 'page' | 'count' | 'setPage'>;

const IssueExceptionsHeader: VoidFunctionComponent<Props> = ({
  search,
  sortBy,
  page,
  count,
  setPage,
  onChangeSortBy,
  onChangeSearch,
}) => {
  const totalCount = useSelector(IssuesV2Store.selectors.getIssueExceptionsCount);
  let sortByLabel: string;
  if (sortBy === ISSUE_EXCEPTION_CREATED_BY_SORT) {
    sortByLabel = 'Created By';
  } else if (sortBy === ISSUE_EXCEPTION_SCOPE_SORT) {
    sortByLabel = 'Ignore Scope';
  } else {
    sortByLabel = 'Package';
  }

  return (
    <Flex
      className={cx(styles.issueExceptionsHeader)}
      justify="space-between"
      align="center"
    >
      <div className={cx(styles.issueExceptionsHeader__searchAndSort)}>
        <SearchInput
          label="Search for ignore rules"
          size="small"
          placeholder="Search for ignore rules"
          value={search}
          onChange={onChangeSearch}
        />
        <DropdownButton
          id="issue-exceptions-sort-by"
          label="Sort by"
          title={<div>Sort by {sortByLabel} <Icon icon={icons.caretDown} /></div>}
          size={BUTTON_SIZE.SMALL}
          value={sortBy}
          noCaret
        >
          <DropdownButton.Item onClick={
            () => onChangeSortBy(ISSUE_EXCEPTION_PACKAGE_SORT)
          }>
            Package
          </DropdownButton.Item>
          <DropdownButton.Item onClick={
            () => onChangeSortBy(ISSUE_EXCEPTION_CREATED_BY_SORT)
          }>
            Created By
          </DropdownButton.Item>
          <DropdownButton.Item onClick={
            () => onChangeSortBy(ISSUE_EXCEPTION_SCOPE_SORT)
          }>
            Ignore Scope
          </DropdownButton.Item>
        </DropdownButton>
      </div>
      <PaginationRangeWithControl
        page={page}
        count={count}
        totalItems={totalCount}
        setPage={setPage}
      />
    </Flex>
  );
};

export default IssueExceptionsHeader;
